/**
 * WGParticipation Component - Working Group Participation Statistics Display - By John Bellew - Infinia.ie - last updated 10/07/2025
 * 
 * Simple statistics card grid component for displaying working group participation metrics.
 * Renders a responsive grid of stat cards with icons, values, and labels using dynamic
 * color theming for each statistic card.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {Array} props.data - Array of participation statistics objects
 * @param {string|number} props.data[].id - Unique identifier for the statistic
 * @param {string} props.data[].icon - CSS class name for FontAwesome icon
 * @param {string|number} props.data[].value - Statistical value to display
 * @param {string} props.data[].label - Label/description for the statistic
 * @param {string} props.data[].color - CSS color value for theming the card
 * @returns {JSX.Element|null} The WGParticipation component or null if no data
 * 
 * @example
 * const stats = [
 *   { id: 1, icon: 'fas fa-users', value: '25', label: 'Active Members', color: '#007bff' }
 * ];
 * <WGParticipation data={stats} />
 */

import React from 'react';
import './WGParticipation.css';

function WGParticipation({ data }) {
  if (!data) {
    return null;
  }

  return (
    <div className="wg-participation-container">
      <div className="wg-participation-grid">
        {data.map((stat) => (
          <div key={stat.id} className="stat-card">
            <div className="stat-icon" style={{color: stat.color}}>
              <i className={stat.icon}></i>
            </div>
            <div className="stat-content">
              <div className="stat-value" style={{color: stat.color}}>{stat.value}</div>
              <div className="stat-label" style={{color: stat.color}}>{stat.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WGParticipation;